<template>
    <div class="ruta-form">
        <div class="form-header">
            <span class="form-title h2">
                <i class="fa-solid fa-route"></i>
                Ruta
            </span>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">
            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarRuta" novalidate>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Ruta Autorizada" label-for="idRutaAutorizada">
                                <b-form-input id="idRutaAutorizada" v-model="form.idRutaAutorizada"
                                    placeholder="Ej: 9394" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Vía" label-for="via">
                                <b-form-input id="via" v-model="form.via" type="number" min="1" placeholder="Ej: 2"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Origen" label-for="idOrigen">
                                <b-form-input id="idOrigen" v-model="form.idOrigen" placeholder="Ej: 05093000"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Detalle Origen" label-for="detalleOrigen">
                                <b-form-input id="detalleOrigen" v-model="form.detalleOrigen" placeholder="Ej: Betulia"
                                    required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="ID Destino" label-for="idDestino">
                                <b-form-input id="idDestino" v-model="form.idDestino" placeholder="Ej: DEST-001"
                                    required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Detalle Destino" label-for="detalleDestino">
                                <b-form-input id="detalleDestino" v-model="form.detalleDestino"
                                    placeholder="Ej: Terminal Norte" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Centro Poblado Origen" label-for="centroPobladoOrigen">
                                <b-form-input id="centroPobladoOrigen" v-model="form.centroPobladoOrigen"
                                    placeholder="Ej: Ciudad A" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Centro Poblado Destino" label-for="centroPobladoDestino">
                                <b-form-input id="centroPobladoDestino" v-model="form.centroPobladoDestino"
                                    placeholder="Ej: Ciudad B" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mb-4">
                        <b-col cols="12">
                            <b-form-group label="Observaciones" label-for="observaciones">
                                <b-form-textarea id="observaciones" v-model="form.observaciones"
                                    placeholder="Ej: Sin novedades" rows="3" required />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Ruta' }}
                        </b-button>
                    </div>

                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>



<script>
export default {
    name: 'FormularioRuta',
    data() {
        return {
            loading: false,
            collapsed: true,
            form: {
                idRutaAutorizada: '',
                idOrigen: '',
                detalleOrigen: '',
                idDestino: '',
                detalleDestino: '',
                via: null,
                centroPobladoOrigen: '',
                centroPobladoDestino: '',
                observaciones: ''
            }
        }
    },
    props: {
        preCarga: {
            type: Object,
            default: null

        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        idRutaAutorizada: val.id_ruta_autorizada ?? '',
                        idOrigen: val.id_origen ?? '',
                        detalleOrigen: val.detalle_origen ?? '',
                        idDestino: val.id_destino ?? '',
                        detalleDestino: val.detalle_destino ?? '',
                        via: val.via ?? null,
                        centroPobladoOrigen: val.centro_poblado_origen ?? '',
                        centroPobladoDestino: val.centro_poblado_destino ?? '',
                        observaciones: val.observaciones ?? ''
                    };
                }
            }
        }
    },
    methods: {
        async registrarRuta() {
            this.loading = true;
            const data = { ...this.form };
            console.log("Formulario enviado:", data);
            this.$emit('submit', data, 'CrearRuta');
            this.loading = false;

        }

    }
}


</script>


<style scoped>
.ruta-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #ffffff;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}



.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
